export const pushDataLayer = e => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: e });
};
